// extracted by mini-css-extract-plugin
export default {"heading1":"heading1__fDT4w","button":"button__7uWMI","box":"box__mXf92","background":"background__VvpmQ","input":"input__1Gy2a"};